<template>
  <div>
    <div
      class="bg-fixed"
      :class="{'bg_i6_tp': isThaiCharoenPlus, 'bg_i6_sc': isSevenColor, 'bg_i6_ts': isThaisiam, 'bg_i6_hp': isHuaypromt, 'bg_i6_jj': isJertjarat, 'bg_i6_ls': isLottoslot88, 'bg_i6_cc': isChokCharoen, 'bg_i6_bc': isBooncharern , 'bg_i6_cci': isCherdchai, 'bg_i6_scr': isSapcharern, 'bg_i6': isDefaultSite}"
    ></div>
    <div class="py-5">
      <div class="container">
        <!-- <ContactUs /> -->
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <form
              @submit.prevent="login"
            >
              <div
                class="img px-4 animateMe animated fadeInDown"
                data-animation=""
              >
                <img
                  v-if="isThaiCharoenPlus"
                  src="@/assets/v3/logo-sd-tp.png"
                  class="logo-img-tp"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                />
                <img 
                  v-else-if="isSevenColor" 
                  src="@/assets/v3/logo-sd-mc.png"
                  class="logo-img-tp"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isThaisiam" 
                  src="@/assets/v3/logo-sd-ts.png"
                  class="logo-img-ts"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isHuaypromt" 
                  src="@/assets/v3/logo-sd-hp.png"
                  class="logo-img-hp"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isJertjarat" 
                  src="@/assets/v3/logo-sd-jj.png"
                  class="logo-img-default"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isLottoslot88" 
                  src="@/assets/v3/logo-sd-ls.png"
                  class="logo-img-default"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isChokCharoen" 
                  src="@/assets/v3/logo-sd-cc.png"
                  class="logo-img-cc"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isBooncharern" 
                  src="@/assets/v3/logo-sd-bc.png"
                  class="logo-img-cc"
                  alt="Logo" 
                  height="auto"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isCherdchai"
                  src="@/assets/v3/logo-sd-cci.png"
                  class="logo-img"
                  alt="Logo" 
                  width="160"
                  fetchpriority="high"
                  decoding="async"
                >
                <img 
                  v-else-if="isSapcharern"
                  src="@/assets/v3/logo-sd.png"
                  class="logo-img-sc"
                  alt="Logo" 
                  width="160"
                  fetchpriority="high"
                  decoding="async"
                >
                <img
                  v-else
                  src="@/assets/v3/logo-sd.png"
                  class="logo-img"
                  alt="Logo" 
                  width="214"
                  height="90"
                  fetchpriority="high"
                  decoding="async"
                />
              </div>

              <div
                class="my-5 pb-5 animateMe animated fadeInUp"
                data-animation="fadeInUp"
              >
                <h5
                  class="text-center w-100 mb-3 theme-main-text"
                >
                  ลงชื่อเข้าใช้งาน
                </h5>
                <div 
                  class="box_shadow bg_c9 p-2 bdr-10" 
                  :class="{'bg_c9_bc': isBooncharern, 'bg_c9_cci': isCherdchai}"
                >
                  <input
                    v-model="username"
                    type="text"
                    class="form-control border-0"
                    :class="{'bg_c9_bc': isBooncharern, 'bg_c9_cci': isCherdchai}"
                    placeholder="กรอกเบอร์โทรศัพท์"
                    @keydown="preventUsername"
                  />
                </div>
                <div 
                  class="box_shadow bg_c9 p-2 bdr-10 mt-4" 
                  :class="{'bg_c9_bc': isBooncharern, 'bg_c9_cci': isCherdchai}"
                >
                  <input
                    v-model="password"
                    type="password"
                    class="form-control border-0"
                    :class="{'bg_c9_bc': isBooncharern, 'bg_c9_cci': isCherdchai}"
                    placeholder="กรอกรหัสผ่าน"
                  />
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <router-link
                    :to="{ name: ROUTE_V3_REGISTER }"
                    class="txt-hover"
                  >
                    <span
                      class="theme-main-text"
                    >ยังไม่เป็นสมาชิก?</span>
                  </router-link>

                  <div class="text-end">
                    <router-link
                      :to="{ name: ROUTE_V3_FORGOT_PASSWORD }"
                      class="txt-hover"
                    >
                      <ins
                        class="theme-main-text"
                      >ลืมรหัสผ่าน</ins>
                    </router-link>
                  </div>
                </div>
              </div>

              <button
                class="button-main bdr-20 bg_c2 bg_c3_login c-white mb-3 w-show animateMe animated fadeInUp"
                data-animation="fadeInUp"
                :disabled="$v.$invalid"
              >
                เข้าสู่ระบบ
              </button>

              <router-link
                :to="{ name: ROUTE_V3_REGISTER }"
                class="button-main bdr-20 bg_c3 c-white mb-3 w-show animateMe animated fadeInUp"
                :class="{'bg_c3_bc': isBooncharern || isCherdchai || isSapcharern}"
                data-animation="fadeInUp"
              >
                สมัครสมาชิก
              </router-link>

              <div class="m-show mt-5">
                <button
                  class="button-main bdr-20 bg_c3 bg_c3_login c-white mb-3 animateMe animated fadeInUp"
                  data-animation="fadeInUp"
                  :disabled="$v.$invalid"
                >
                  เข้าสู่ระบบ
                </button>

                <router-link
                  :to="{ name: ROUTE_V3_REGISTER }"
                  class="button-main bdr-20 bg_c3 c-white mb-3 animateMe animated fadeInUp"
                  :class="{'bg_c3_bc': isBooncharern || isCherdchai}"
                  data-animation="fadeInUp"
                >
                  สมัครสมาชิก
                </router-link>

                <!-- <router-link
                  :to="{ name: ROUTE_INDEX }"
                  class="button-main bdr-20 bg_c14 border-0 c-white animateMe animated"
                >
                  <i class="fas fa-chevron-left me-2"></i>กลับสู่หน้าแรก
                </router-link> -->
              </div>
              <div class="login-option-menu">
                <login-option-menu></login-option-menu>
              </div>
              <div class="login-card-result">
                <card-result></card-result>
              </div>
              <div class="x-banner">
                <banner></banner>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate' 
import { ROUTE_INDEX, ROUTE_V3_REGISTER, ROUTE_V3_FORGOT_PASSWORD } from '@/const/route'
import { auth as apiAuth } from '@/apis' 
import { required } from 'vuelidate/lib/validators'
import { preventUsername } from '@/utils/preventkeydown'
import LoginOptionMenu from './childs/LoginOptionMenu'
import Banner from './childs/Banner'
import CardResult from '@/views-v2/Login/childs/CardResult'

export default {
  components: {
    LoginOptionMenu,
    Banner,
    CardResult
  },
  mixins: [validationMixin],
  data () {
    return {
      ROUTE_INDEX,
      ROUTE_V3_REGISTER,
      ROUTE_V3_FORGOT_PASSWORD,
      username: '',
      password: ''
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    }
  },
  methods: {
    preventUsername,
    async login () {

      if (this.$v.$invalid) {
        return
      }

      let form = {
        username : this.username,
        password : this.password,
        device: 'web',
        domain: window.location.host
      }

      const [err, data] = await apiAuth.login(form)

      if (data === null || data.length == 0) {
        this.$alert('', err, 'warning')
        return
      }

      if (data.reset_password) {
        this.$router.push({ name: ROUTE_V3_FORGOT_PASSWORD }).catch(() => {});  
        return
      }

      localStorage.setItem('access-Token', data.access_token)

      this.$store.commit('auth/MUTATION_TOKEN', data.access_token)

      this.$store.commit('userProfile/MUTATION_ME', data.user_profile)
      
      this.$router.push({ name: ROUTE_INDEX }).catch(() => {
        this.$router.go()
      });  
    }
  }
};
</script>

<style scoped>
button {
  width: 100%;
}
button:disabled {
  background: var(--v3-btn-login-color);
}
.login-option-menu {
  display: flex;
  margin-top: 24px;
  width: 100%;
  padding: 0 12px;
}

.img {
  display: flex;
  justify-content: center;
}

.logo-img {
  width: 60%;
}

.logo-img-tp {
  width: 40%;
}

.logo-img-ts {
  width: 100%;
}

.logo-img-hp {
  width: 40%;
}

.logo-img-default {
  width: 100%;
}

.logo-img-cc {
  width: 100%;
}

.logo-img-sc {
  width: 60%;
  opacity: 0;
}


.x-banner {
  margin-top: 20px;
}

.login-card-result {
  margin-top: 16px;
}

.bg_c9_bc {
  background-color: #d9d9d9;
}

.bg_c9_cci {
  background-color: #d9d9d9;
}

.bg_c3_bc {
  background: linear-gradient(90deg, var(--v3-btn-login-color-20) 0%, var( --v3-btn-login-color-20-end) 100%) !important;
}

</style>
